import React from 'react';
import { Col, Image } from 'react-bootstrap';
import featuresLogo1 from '../../assets/images/toolkit.png';
import featuresLogo2 from '../../assets/images/checkbox.png';
import featuresLogo3 from '../../assets/images/tailors-tape.png';
import featuresLogo4 from '../../assets/images/calender.png';

const Features = () => (
  <div className="show-grid">
    <div className="main-key-grid">
      <Col md={4} className="first-key-grid">
        {/*<Image src={mainImg} responsive />*/}
        <h2 className="key-h2-grid">Key Features</h2>
        <p className="key-first-text">
          <strong>Wanting to be more aware of God’s presence won’t make it happen.</strong> If you don’t learn to trust
          and train, you will become a spectator to a less-than-abundant life rather than dwelling in the presence of
          God. We’ve created Presence to provide you with the consistency and variety to help you enjoy the process of
          becoming intentional in practicing the presence of God.
        </p>
      </Col>
      <Col md={8} className="second-key-grid">
        <Col md={12} className="block-md-12">
          <Col md={6} sm={6} className="main-grid-block">
            <div className="img-key-grid toolkit-icon">
              <Image src={featuresLogo1} />
            </div>
            <div className="block-key-grid">
              <h3 className="key-h3-grid">Practical</h3>
              <p>
                Presence creates a tool kit for engaging and enjoying your everyday, already scheduled activities.
                Cultivate new practices without the strain of multitasking.
              </p>
            </div>
          </Col>
          <Col md={6} sm={6} className="main-grid-block">
            <div className="img-key-grid checkbox-icon">
              <Image src={featuresLogo2} />
            </div>
            <div className="block-key-grid">
              <h3 className="key-h3-grid">Simple</h3>
              <p>
                Just a simple YES or NO and Presence saves or deletes an exercise for your personal plan. If you want to
                repeat an exercise before moving on, just hit REPEAT.
              </p>
            </div>
          </Col>
        </Col>
        <Col md={12} className="block-md-12">
          <Col md={6} sm={6} className="main-grid-block">
            <div className="img-key-grid tailors-icon">
              <Image src={featuresLogo3} />
            </div>
            <div className="block-key-grid">
              <h3 className="key-h3-grid">Personal</h3>
              <p>
                Discover new likes. Repeat favorites. Delete what doesn’t appeal. God made us all different, so Presence
                offers 8 categories of 13 exercises.
              </p>
            </div>
          </Col>
          <Col md={6} sm={6} className="main-grid-block">
            <div className="img-key-grid calender-icon">
              <Image src={featuresLogo4} />
            </div>
            <div className="block-key-grid">
              <h3 className="key-h3-grid">Consistent</h3>
              <p>
                Presence app’s weekly reminder of your 1 - 2 exercises helps you stay on track. No need to worry about
                forgetting or becoming overwhelmed.
              </p>
            </div>
          </Col>
        </Col>
      </Col>
    </div>
  </div>
);

export default Features;



// WEBPACK FOOTER //
// ./src/components/Landing/Features.js